var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.35 31.02",
    style: {
      enableBackground: "new 0 0 31.35 31.02"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0D4E5F;}\n\t.st1{fill:#104E5F;}\n\t.st2{fill:#0E576B;}\n\t.st3{fill:#41B073;}\n\t.st4{fill:#91C793;}\n\t.st5{fill:#179CC0;}\n\t.st6{fill:#70C8E7;}\n\t.st7{fill:#A2CF9C;}\n\t.st8{fill:#70C9E8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.02,12.94c-0.14-0.77-0.33-1.52-0.58-2.25C22.38,17.9,12.29,21.92,1.67,21.02 c1.85,4.62,5.98,8.19,11.24,9.1c1.19,0.21,2.38,0.26,3.53,0.18C19.03,23.04,23.88,17.02,30.02,12.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.93,28.24c0.91-5.3,3.58-9.86,7.31-13.18c-0.02-0.72-0.1-1.42-0.22-2.11 c-6.14,4.09-10.99,10.1-13.57,17.36c2.32-0.16,4.53-0.86,6.47-2C22.92,28.27,22.93,28.26,22.93,28.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M22.92,28.29c3.63-2.13,6.34-5.79,7.11-10.27c0.17-1,0.24-1.99,0.21-2.97c-3.73,3.32-6.4,7.88-7.31,13.18 C22.93,28.26,22.92,28.27,22.92,28.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.44,10.69c-0.2-0.58-0.43-1.14-0.7-1.69c-5,4.35-11.85,6.5-18.89,5.29c-3.14-0.54-6.01-1.69-8.53-3.32 C1.12,11.63,0.95,12.3,0.83,13c-0.48,2.8-0.14,5.56,0.84,8.02C12.29,21.92,22.38,17.9,29.44,10.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M17.94,0.91C10.57-0.36,3.54,4.05,1.33,10.97c2.51,1.62,5.39,2.78,8.53,3.32C16.89,15.5,23.73,13.35,28.74,9 C26.72,4.88,22.81,1.75,17.94,0.91z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.b383ec6f7306794e53912bfb8f3812f8.svg";
export { ForwardRef as ReactComponent };